module.exports = __webpack_public_path__ + "static/staff_of_withering-c2f3ad3ed4e144d8b13da03328846d37.jpeg";